import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import type { LiveCasinoGame } from '@swf/core/types/CasinoGame';

import styles from './LiveCasinoGameStatus.scss';
import MetaMessage, { hasStatus } from './MetaMessage';

export interface Props {
  className: string;
  game: LiveCasinoGame;
}

export const overlapAbove = (game: LiveCasinoGame) => Array.isArray(game.statusMeta.results);

const LiveCasinoGameStatus: React.FC<Props> = ({ className, game }) => {
  const full = game.maxSeats === game.statusMeta.numPlayers;
  const isEmbedded = useSelector(select.site.isEmbedded);

  const cls = classNames(styles.container, {
    [styles.full]: full
  });

  return hasStatus(game) ? (
    <div className={classNames(styles.wrap, className, { [styles.embedded]: isEmbedded })}>
      <div className={styles.innerWrap}>
        <MetaMessage game={game} full={full} className={cls} />
      </div>
    </div>
  ) : null;
};

export default LiveCasinoGameStatus;
